import { AppState } from "@Safemate/Store/types";

export const selectLastDeviceModifiedTime = ({ transactionLog: { device: { lastDeviceModifiedTime } } }: AppState) => lastDeviceModifiedTime;
export const selectDevices = ({ transactionLog: { device: { devices } } }: AppState) => devices;
export const selectFilteredDevices = ({ transactionLog: { device: { filteredDevices } } }: AppState) => filteredDevices;
export const selectFilterSelector = ({ transactionLog: { transaction: { alarmFilter } } }: AppState) => alarmFilter;